import {
    Tooltip,
    IconButton
} from '@material-ui/core';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import ShareIcon from '@material-ui/icons/Share';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import EyeIcon from '@material-ui/icons/Visibility';
import ReplyIcon from '@material-ui/icons/Reply';
import NotificationsIcon from '@material-ui/icons/Notifications';

const useStyles = makeStyles(theme => ({
    icon: {
        fill: 'inherit !important'
    }
}));

const ActionGroup = ({
    onDelete,
    onShare,
    onEdit,
    onCopy,
    onView,
    onReply,
    onSend
}) => {
    const classes = useStyles();
    return (
        <React.Fragment>
            {
                onCopy &&
                <Tooltip title={"Copier"}>
                    <IconButton onClick={onCopy}>
                        <FileCopyIcon className={classes.icon} />
                    </IconButton>
                </Tooltip>
            }
            {
                onShare &&
                <Tooltip title={"Share"}>
                    <IconButton onClick={onShare}>
                        <ShareIcon className={classes.icon} />
                    </IconButton>
                </Tooltip>
            }
            {
                onEdit &&
                <Tooltip title={"Modifier"}>
                    <IconButton onClick={onEdit}>
                        <EditIcon className={classes.icon} />
                    </IconButton>
                </Tooltip>
            }
            {
                onDelete &&
                <Tooltip title={"Supprimer"}>
                    <IconButton onClick={onDelete}>
                        <DeleteIcon className={classes.icon} />
                    </IconButton>
                </Tooltip>
            }
            {
                onView &&
                <IconButton onClick={onView}>
                    <EyeIcon className={classes.icon} />
                </IconButton>
            }
            {
                onReply &&
                <Tooltip title={"Reply"}>
                    <IconButton onClick={onReply}>
                        <ReplyIcon className={classes.icon} />
                    </IconButton>
                </Tooltip>
            }
            {
                onSend &&
                <Tooltip title={"Envoyer une notification"}>
                    <IconButton onClick={onSend}>
                        <NotificationsIcon className={classes.icon} />
                    </IconButton>
                </Tooltip>
            }
        </React.Fragment>
    );
};
ActionGroup.propTypes = {
    onDelete: PropTypes.func,
    onShare: PropTypes.func,
    onEdit: PropTypes.func,
    onCopy: PropTypes.func,
    onView: PropTypes.func,
    onReply: PropTypes.func,
    onSend: PropTypes.func
};

export default ActionGroup;
